<div class="mat-body">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button [mat-dialog-close]="false">
        <mat-icon>close</mat-icon>
    </button>

    <p class="mat-headline mb-4">{{ 'terms.terms-and-conditions' | translate }}</p>

    <div class="scrollable mb-4">
        <p class="mb-3"><b>1.</b> {{ type + '.paragraph1.part1'| translate }}</p>
        <ul class="mb-3">
            <li>{{ type + '.paragraph1.list.1'| translate }}</li>
            <li>{{ type + '.paragraph1.list.2'| translate }}</li>
            <li
                *ngIf="orderType === OrderType.REFUND || orderType === OrderType.REFUND_PERIOD
                || orderType === OrderType.SUBSCRIPTION || orderType === OrderType.SUBSCRIPTION_PERIOD"
            >
                {{ type + '.paragraph1.list.3'| translate }}
            </li>
            <li>{{ type + '.paragraph1.list.4'| translate }}</li>
        </ul>
        <p class="mb-4">{{ type + '.paragraph1.part2'| translate }}</p>
        <p class="mb-4"><b>2.</b> {{ type + '.paragraph2'| translate }}</p>
        <p class="mb-4"><b>3.</b> {{ type + '.paragraph3'| translate }}</p>
        <p class="mb-4"><b>4.</b> {{ type + '.paragraph4'| translate }}</p>
        <p class="mb-4"><b>5.</b> {{ type + '.paragraph5'| translate }}</p>
        <p class="mb-4"><b>6.</b> {{ type + '.paragraph6'| translate }}</p>
        <p class="mb-4"><b>7.</b> {{ type + '.paragraph7'| translate }}</p>
        <p class="mb-4"><b>8.</b> {{ type + '.paragraph8'| translate }}</p>
        <p class="mb-4"><b>9.</b> {{ type + '.paragraph9'| translate }}</p>
        <p class="mb-4"><b>10.</b> {{ type + '.paragraph10'| translate }}</p>
        <p
            [class.mb-4]="orderType !== OrderType.REFUND && orderType !== OrderType.REFUND_PERIOD
            && orderType !== OrderType.SUBSCRIPTION && orderType !== OrderType.SUBSCRIPTION_PERIOD"
        >
            <b>11.</b> {{ type + '.paragraph11'| translate }}
        </p>
        <p
            *ngIf="orderType !== OrderType.REFUND && orderType !== OrderType.REFUND_PERIOD
            && orderType !== OrderType.SUBSCRIPTION && orderType !== OrderType.SUBSCRIPTION_PERIOD"
        >
            <b>12.</b> {{ type + '.paragraph12'| translate}}
        </p>
    </div>

    <div>
        <div class="row justify-content-center">
            <div class="col-12 col-sm-6">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [mat-dialog-close]="false">
                    {{ 'general.accept' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>
